"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Checkbox;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deburr = _interopRequireDefault(require("lodash/deburr"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CheckboxModule = _interopRequireDefault(require("./Checkbox.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Checkbox.propTypes = {
  input: _propTypes.default.shape({
    checked: _propTypes.default.bool,
    name: _propTypes.default.string.isRequired,
    value: _propTypes.default.string
  }).isRequired,
  meta: _propTypes.default.object,
  name: _propTypes.default.string.isRequired,
  size: _propTypes.default.oneOf(['sm', 'md', 'lg'])
};

function Checkbox(_ref) {
  var children = _ref.children,
      _ref$input = _ref.input,
      input = _ref$input === void 0 ? {} : _ref$input,
      onClick = _ref.onClick,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size;
  var classes = (0, _classnames.default)(_CheckboxModule.default.Wrapper, className, _defineProperty({}, _CheckboxModule.default[size], size));
  var name = input.name,
      checked = input.checked,
      value = input.value;
  var active = checked || !!value;
  var id = value ? "".concat(name, "-").concat((0, _deburr.default)(value)) : name;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    checked: active,
    "aria-checked": active
  }, input, {
    id: id,
    onClick: onClick,
    className: _CheckboxModule.default.Checkbox,
    type: "checkbox"
  })), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: _CheckboxModule.default.Label
  }, children));
}

//# sourceMappingURL=Checkbox.js.map